// src/pages/Projects.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const sections = [
  {
    title: 'Academic Projects',
    items: [
      { to: '/projects/PredictivePolicing', label: 'Predictive Policing' },
    ],
  },
  {
    title: 'Games',
    items: [
      { to: '/projects/SixShotShowdown', label: 'Six Shot Showdown' },
      { to: '/projects/Pirate', label: 'Pirate TTRPG' },
      { to: '/projects/EscapeTheMaze', label: 'Escape the Maze' },
      { to: '/projects/PainfulPaint', label: 'Painful Paint' },
    ],
  },
  {
    title: 'Warhammer Projects',
    items: [
      { to: '/projects/PyrrhicWar', label: 'Pyrrhic War' },
      { to: '/projects/Expedition', label: 'Expedition' },
      { to: '/projects/DeploymentZoneCreator', label: 'Deployment Zone Creator' },
      { to: '/projects/KillTeamCampaign', label: 'Kill Team Campaign Map' },
      
    ],
  },
];

const styles = {
  page: {
    padding: '40px',
    color: '#F3E5AB',
    fontFamily: 'Milonga, serif',
    textAlign: 'center',
  },
  section: {
    marginBottom: '28px',
  },
  heading: {
    fontSize: '32px',
    margin: '0 0 10px',
  },
  list: {
    fontSize: '22px',
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  item: {
    marginBottom: '6px',
  },
  link: {
    color: '#C0A96B',
    textDecoration: 'none',
  },
};

export default function Projects() {
  return (
    <div style={styles.page}>
      {sections.map((section) => (
        <section key={section.title} style={styles.section}>
          <h1 style={styles.heading}>{section.title}</h1>
          <ul style={styles.list}>
            {section.items.map((item) => (
              <li key={item.to} style={styles.item}>
                <Link to={item.to} style={styles.link}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
